const users = {
  name: 'mUsers',
  path: 'users',
  meta: {
    title: '选择账户'
  },
  component: resolve => require(['../../../pages/m/users'], resolve)
}

export default users
